import { Calendar, CalendarGroupExtended } from 'owa-calendar-cache';
import CalendarEntry from 'owa-service/lib/contract/CalendarEntry';
import CalendarFolder from 'owa-service/lib/contract/CalendarFolder';
import LocalCalendarEntry from 'owa-service/lib/contract/LocalCalendarEntry';
import { action } from 'satcheljs';
import { MailboxInfo } from 'owa-client-ids';
import { processResponse } from './getSelectedTeamsCalendarsServiceUtils';
import { getTeamsChannelsSDS } from 'owa-teams-sds';

export interface TeamsCalendarsResult {
    entry: CalendarEntry | LocalCalendarEntry;
    folder: CalendarFolder;
    mailboxInfo: MailboxInfo;
}

export interface GetSelectedTeamsChannelsCalendarsServiceResult {
    groupCalendars: TeamsCalendarsResult[];
    calendarGroup: CalendarGroupExtended;
    calendars: Calendar[];
}

async function getTeamsChannels(): Promise<GetSelectedTeamsChannelsCalendarsServiceResult | null> {
    const result = await getTeamsChannelsSDS();
    if (result != null) {
        return processResponse(result);
    }

    return null;
}

const getTeamsCalendarsService = action('getTeamsCalendarsService', () => getTeamsChannels());

export default getTeamsCalendarsService;
